/* eslint-disable no-unused-expressions */
import withAdminDashboard from "../../../HOC/withAdminDashboard";
import withActivityLayout from "../../../../../components/Common/HOC/withActivityLayout";
import procurementAPI from "../../../../../redux/api/procurementAPI";

const CompleteReport = () => (
  withActivityLayout(() => null)({
    title: "Completion Report",
    postAPI: procurementAPI.savePlanDocument,
    getAPI: procurementAPI.getPlanDocuments,
    extraCrumbs: [
      {
        url: "#",
        title: "Completion Report",
      },
    ]
  })
);

export default withAdminDashboard(CompleteReport);
